module.exports = __webpack_public_path__ + "static/media/browser.da8058c6.svg";